import {AxiosError} from 'axios';
import {GET_ADMIN_AUDIT_LOG_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_ADMIN_AUDIT_LOG} from '../../constants/apiUrls';
import {PaginatedData} from '../../models/List';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================

export interface AuditContent {
  userName: string;
  userRole: string;
  item: string;
  changeSummary: {
    baseFieldName: string;
    fieldName: string;
    before: string;
    after: string;
  };
  dateTime: string;
}

interface Input {
  uuid: string;
  page: number | undefined;
  size: number | undefined;
  onSuccess?: (data: any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetAdminAuditLog = ({uuid, page, size, onSuccess, onError, enabled}: Input) => {
  const getAdminAuditLog = async () => {
    const res = await axiosClient.get<PaginatedData<AuditContent>>(
        GET_ADMIN_AUDIT_LOG(uuid, page, size)
    );
    return res.data;
  };

  return useCustomQuery(GET_ADMIN_AUDIT_LOG_QUERY_KEY, getAdminAuditLog, {
    onSuccess,
    onError,
    enabled,
  });
};
